<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/>
    <!-- <menu001 v-if="!origin.includes('https')"></menu001> -->
    <popout v-show="other.isGoOverdue" :popData="popData" @confirmFn="confirmFn" @cancelFn="cancelFn"></popout>
  </div>
</template>

<script>
  import menu001 from '../src/components/menu/menu001'
  import popout from './components/public/popout'
  import {mapState, mapMutations} from 'vuex';

  export default {
    name: 'App',
    components: {menu001, popout},
    data() {
      return {
        popData: {
          title: "您的感恩券即将到期，请在“感恩券”页面了解详情。",
          confirmText: "查看",
          cancelText: "取消",
        }
      }
    },
    created() {
      /*有过期优惠券的提示*/
      /*      this.isIncludeExpiredCoupons()
              .then((data) => {
                if (data) {
                  this.bol = true;
                }
              })
              .catch(() => {

              })*/
    },
    mounted() {

    },
    methods: {
      ...mapMutations('my', ['otherFn']),
      confirmFn() {
        this.otherFn({
          isGoOverdue: false,
        });
        this.$router.push({path: "/discountCoupon"})
      },
      cancelFn() {
        this.otherFn({
          isGoOverdue: false,
        });
      },
    },
    computed: {
      ...mapState('my', ['other']),
    },
  }
</script>

<style lang="scss">
  @import "../static/css/common.css";
  @import "../static/css/long.scss";

  #app {
    font-family: Arial, "Microsoft YaHei", "lucida grande",
    "lucida sans unicode", lucida, helvetica, "Hiragino Sans GB",
    "WenQuanYi Micro Hei", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue